import { Accordion, Checkbox, P } from '@dnb/eufemia';
import styled from '@emotion/styled';
import { useSearchParams } from 'react-router-dom';

const StyledAccordion = styled(Accordion)`
  --accordion-header-margin-vertical: 0.2rem;
  --accordion-header-wrapper-margin--icon-right: 0;
  --accordion-content-margin: 0.3rem 0 1rem 0;
  --accordion-title-font-weight: 500;
`;

interface Props {
  label: string;
  filterKey: 'stage' | 'classification' | 'serviceDomainId' | 'tags';
  values: {
    label: string;
    subLabel?: string | null;
    value: string;
    count: number;
  }[];
}

export function FacetFilter({ label, filterKey, values }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedFacetValues = searchParams.getAll(filterKey);

  const handleChange = (checked: boolean, value: string) => {
    const updated = checked ? [...selectedFacetValues, value] : selectedFacetValues.filter((v) => v !== value);

    setSearchParams((prev) => {
      prev.delete(filterKey);
      updated.forEach((v) => prev.append(filterKey, v));
      prev.delete('page'); // Reset page index on filter change
      return prev;
    });
  };

  return (
    <StyledAccordion expanded icon_position="right" title={label} variant="plain">
      <div className="flex flex-col gap-2">
        {values.map((value) => (
          <Checkbox
            checked={selectedFacetValues.includes(value.value)}
            key={value.value}
            label={
              <>
                <P>
                  {value.label} ({value.count})
                </P>
                {value.subLabel && <P className="text-black-55">{value.subLabel}</P>}
              </>
            }
            onChange={({ checked }) => handleChange(checked, value.value)}
            size="medium"
          />
        ))}
      </div>
    </StyledAccordion>
  );
}
